import { type FC } from 'react';

import { type IBank } from '../../types/bank';

import { BankItemController } from './components/BankItem';

import styles from './AccreditedBanks.css';

export interface IAccreditedBanksProps {
  banks: IBank[];
  onBankClick?: (bank: IBank) => void;
}

export const AccreditedBanks: FC<IAccreditedBanksProps> = ({ banks, onBankClick }) => {
  return (
    <div className={styles['container']} data-testid="AccreditedBanks">
      {banks.map(bank => (
        <BankItemController bank={bank} key={bank.id} onLinkClick={onBankClick} />
      ))}
    </div>
  );
};
